import React, { Component, Fragment } from 'react';
import { Button, Table, Modal, message, Breadcrumb } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import { CheckOutlined } from '@ant-design/icons';

import CreateAsset from '../CreateAsset';
import FinalPreview from '../CreateAsset/Final';
import Filter from '../../components/FilterComponent';
import Coins from '../../components/Coins';
import ApplyChangesConfirmation from '../../components/ApplyChangesConfirmation';
import IconToolTip from '../../components/IconToolTip';
import { ExchangeAction, CoinAction } from '../../actions';
import {
    // storeAsset,
    putExchange,
    getExchange,
    updateAssetCoins,
    getCoins,
    requestApplyOnKit,
    getExchangeUsers,
    getExchangeBalance,
    uploadCoinLogo
} from '../../common/fetch';
import { getTabParams } from '../../common/utils';
import { default_coin_data, ASSET_TYPE_LIST } from '../../config/constants';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'
import { CLOUD_PLAN_CRYPTO_PRO, CLOUD_PLAN_FIAT_RAMP } from '../../config/media';
import { Wrapper } from './style';

const { Item } = Breadcrumb;

const filterOptions = [
    { label: 'All', value: 'all', secondaryType: 'text', secondaryPlaceHolder: 'Input name or symbol' },
];

const getColumns = (allCoins = [], user = {}, balance = {}, handleEdit, handlePreview, exchange) => [
    {
        title: 'Assets',
        dataIndex: 'symbol',
        key: 'symbol',
        render: (symbol = '', data) => {
            const selectedAsset = _cloneDeep(allCoins.filter(list => list.symbol === data.symbol)[0]) || {};
            if (!data.id && selectedAsset.id) {
                delete selectedAsset.id;
            }
            if (!selectedAsset.symbol) {
                selectedAsset.symbol = data.symbol
            }
            return (
                <div className="coin-symbol-wrapper" onClick={() => handlePreview(selectedAsset)} >
                    <Coins
                        type={symbol.toLowerCase()}
                        small={true}
                        color={selectedAsset.meta
                            ? selectedAsset.meta.color
                            : ''
                        }
                        fullname={selectedAsset.fullname}
                        onClick={() => handlePreview(selectedAsset)}
                    />
                    <span className="selected-asset">{' '}{selectedAsset.fullname}</span>
                    {(data.id && data.verified)
                        ? <IconToolTip type="success" tip="" animation={false} />
                        : (data.id && !data.verified)
                            ? <IconToolTip
                                type="warning"
                                tip="This asset is in pending verification"
                                onClick={(e) => {
                                    if (selectedAsset.created_by === user.id) {
                                        handleEdit(selectedAsset, e)
                                    }
                                }}
                            />
                            : (selectedAsset.created_by === user.id)
                                ?
                                <div className="config-content">
                                    (<span className="link" onClick={(e) => handleEdit(selectedAsset, e)}>Configure</span>)
                                    <IconToolTip
                                        type="settings"
                                        tip="Click to complete the asset configuration"
                                        onClick={(e) => handleEdit(selectedAsset, e)}
                                    />
                                </div>
                                : null
                    }
                </div>
            )
        }
    },
    {
        title: 'Status',
        dataIndex: 'verified',
        key: 'verified',
        className: 'balance-column',
        render: (verified, data) => {
            const basicCoins = ["btc", "xht", "eth", "usdt"]
            if (verified && (exchange.plan === "basic" || exchange.plan === "crypto" || exchange.plan === "fiat" || exchange.plan === "boost")) {
                if ((exchange.plan === "basic" && basicCoins.includes(data.symbol)) || ((exchange.plan === "crypto" || exchange.plan === "fiat" || exchange.plan === "boost") && data && (data.type === "blockchain" || data.type === "fiat"))) {
                    return <div><CheckOutlined className='status-verified' />verified</div>
                } else if (exchange.plan === "basic" && data && data.type === "blockchain") {
                    return <div> <img alt='crypto-pro' className='plan-img' src={CLOUD_PLAN_CRYPTO_PRO}></img>Crypto Pro required <Link to="/billing" className='text-link'>(Upgrade)</Link></div>
                } else {
                    return <div> <img alt='fiat-ramp' className='plan-img' src={CLOUD_PLAN_FIAT_RAMP}></img>Enterprise or Boost required <Link to="/billing" className='text-link'>(Upgrade)</Link></div>
                }
            } else {
                return <div>pending</div>
            }
        }
    },
];

class Assets extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpenAdd: false,
            isEdit: false,
            width: 620,
            coins: [],
            isPreview: false,
            isConfigure: false,
            isConfigureEdit: false,
            editConfigureScreen: 'edit-supply',
            selectedAsset: {},
            exchange: {},
            filterValues: '',
            status: '',
            tabParams: getTabParams(),
            isConfirm: false,
            exchangeUsers: [],
            userEmails: [],
            isPresetConfirm: false,
            exchangeBalance: {},
            formData: {},
            saveLoading: false,
            isWithdrawalEdit: false,
            currentAssetScreen: '',
            screenChange: false,
        }
    }

    componentDidMount() {
        const { tabParams } = this.state;
        if (this.props.exchange
            && this.props.exchange.length
        ) {
            this.setState({
                coins: this.props.exchange[0].coins || [],
                exchange: this.props.exchange[0]
            });
        }
        if (tabParams) {
            let isAddAsset = (tabParams.isAsset === 'true');
            let isPreview = (tabParams.preview === 'true');
            let coinData = this.props.exchange[0].coins;
            if (coinData.length) {
                let temp = coinData.filter(list => list.symbol === tabParams.symbol)
                let filterCoin = temp.length ? temp[0] : {};
                if (filterCoin.symbol) {
                    let filterSymbol = filterCoin.symbol;
                    filterCoin = this.props.allCoins.filter(list => list.symbol === filterSymbol)[0] || {};
                }
                this.props.handleHide(isPreview);
                this.setState({
                    isPreview,
                    isOpenAdd: isAddAsset,
                    selectedAsset: {
                        ...default_coin_data,
                        ...filterCoin
                    }
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.exchange) !== JSON.stringify(this.props.exchange)
            && this.props.exchange.length
        ) {
            this.setState({
                coins: this.props.exchange[0].coins || [],
                exchange: this.props.exchange[0]
            });
        }
        if (JSON.stringify(this.props.location) !== JSON.stringify(prevProps.location)) {
            const tabParams = getTabParams();
            if (tabParams.tab === '0') {
                this.props.handleHide(false);
                this.setState({
                    isPreview: false,
                    isConfigure: false
                })
            }
        }
        if (JSON.stringify(prevState.exchange) !== JSON.stringify(this.state.exchange)) {
            this.getAllUsers();
            this.getExchangeBalance();
        }
    }
    updateFormData = (name, value) => {
        const { formData } = this.state;
        if (name === 'color') {
            formData.meta = { color: value };
        } else if (name === 'decimal_points') {
            formData.meta = {
                ...formData.meta,
                decimal_points: value
            };
        } else {
            formData[name] = value;
        }
        this.setState({ formData });
    }
    getAllUsers = async () => {
        try {
            const res = await getExchangeUsers(this.state.exchange.id);
            if (res.data && res.data.data) {
                const exchangeUsers = res.data.data || [];
                this.setState({
                    exchangeUsers,
                    userEmails: exchangeUsers.map(user => user.email)
                });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    getExchangeBalance = async () => {
        try {
            const res = await getExchangeBalance(this.state.exchange.id);
            if (res.data) {
                this.setState({
                    exchangeBalance: res.data
                });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    handleScreen = (screen) => {
        this.setState({ currentAssetScreen: screen, screenChange: false });
    }

    handleClose = () => {
        if (this.state.currentAssetScreen === 'step2') {
            this.setState({ screenChange: true });
        } else {
            this.setState({
                isOpenAdd: false,
                isEdit: false,
                isConfigureEdit: false,
                isConfirm: false,
                width: 520,
                isWithdrawalEdit: false,
                screenChange: false
                // selectedAsset: {}
            });
        }
    };

    handleCreateNew = () => {
        this.setState({ isOpenAdd: true });
    };

    handleWidth = (width) => {
        this.setState({ width: width ? width : 520 });
    };

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });

            this.props.actions.readData(exchange);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    getCoins = async () => {
        try {
            const res = await getCoins();
            const coins = await res.data.data.map((item) => {
                // NOTE: Monero set disabled
                if (item.symbol === 'xmr') {
                    return {
                        key: 'Monero',
                        value: 'xmr',
                        disabled: true,
                        ...item
                    };
                }
                const filter = ASSET_TYPE_LIST.filter((obj) => obj.value === item.symbol);
                if (filter.length === 0) {
                    return {
                        key: item.fullname,
                        value: item.symbol,
                        ...item
                    };
                } else {
                    return { ...filter[0], ...item };
                }
            });

            return this.props.setCoin(coins);
        } catch (error) {
            throw error;
        }
    };

    handleRefreshCoin = async (coinData) => {
        const {
            coins,
            exchange
        } = this.state;
        try {
            let coinList = coins.map(data => data.symbol);
            let formProps = {
                id: exchange.id,
                coins: [...coinList, coinData.symbol]
            }
            await putExchange(formProps);
            await this.getExchange();
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message);
            }
        }
    };

    handleConfirmation = async (coinFormData = {}, isEdit = false, isApply = false, isPresetAsset = false, isSaveWithoutApply = false) => {
        const { coins, exchange, isConfigure, selectedAsset } = this.state;
        const { logoFile, iconName, ...coinData } = coinFormData;
        if (isEdit) {
            try {
                this.setState({ saveLoading: true });
                // if (!coinData.logo || selectedAsset.logo) {
                //     coinData.logo = ''
                // }
                delete coinData.key;
                delete coinData.value;
                // delete coinData.iconName;
                // if (coinData.symbol) {
                //     coinData.symbol = coinData.symbol.toLowerCase();
                // }
                // if (isApply || isSaveWithoutApply) {
                //     if (!coinData.network) coinData.network = '';
                //     if (!coinData.standard) coinData.standard = '';
                //     if (!coinData.estimated_price) {
                //         coinData.estimated_price = 1;
                //     }
                // }
                // if (!coinData.fullname) coinData.fullname = selectedAsset.fullname;
                // if (!coinData.symbol) coinData.symbol = selectedAsset.symbol;
                // if (!coinData.min) coinData.min = selectedAsset.min;
                // if (!coinData.max) coinData.max = selectedAsset.max;
                // if (!coinData.increment_unit) coinData.increment_unit = selectedAsset.increment_unit;
                if (!coinData.code) coinData.code = selectedAsset.code;
                if (logoFile) {
                    let formData = new FormData();
                    formData.append('exchange_name', this.props.state.EXCHANGE_NAME);
                    formData.append('file_name', iconName);
                    formData.append('file', logoFile);
                    const logo = await uploadCoinLogo(formData);
                    coinData.logo = _get(logo, 'path', '');
                }
                await updateAssetCoins(coinData);
                await this.getCoins();
                this.setState({ formData: {}, saveLoading: false });
                if (isApply) {
                    await this.handleApply();
                }
                message.success('Assets updated successfully');
                this.handleClose();
                if (isConfigure) {
                    this.setState({ isConfigure: false, isPreview: true, formData: {} })
                }
            } catch (error) {
                this.setState({ saveLoading: false });
                if (error && error.data) {
                    message.error(error.data.message)
                }
            }
        } else {
            try {
                this.setState({ saveLoading: true });
                if (!coinData.logo) {
                    coinData.logo = ''
                }
                delete coinData.key;
                delete coinData.value;
                delete coinData.iconName;
                if (coinData.symbol) {
                    coinData.symbol = coinData.symbol.toLowerCase();
                }
                // let pairs = exchange.pairs || [];
                let coinList = coins.map(data => data.symbol);
                let paramsData = {
                    allow_deposit: coinData.allow_deposit,
                    allow_withdrawal: coinData.allow_withdrawal,
                    estimated_price: coinData.estimated_price,
                    increment_unit: coinData.increment_unit,
                    max: coinData.max,
                    min: coinData.min,
                    withdrawal_fee: coinData.withdrawal_fee,
                    code: !coinData.code ? coinData.symbol.toLowerCase() : coinData.code
                }
                if (!coinData.id) {
                    const res = await updateAssetCoins(paramsData);
                    this.props.addCoin(res.data);
                }
                if (!coinList.includes(coinData.symbol)) {
                    let formProps = {
                        id: exchange.id,
                        // pairs: pairs.map(data => data.name ? data.name : data.symbol),
                        coins: [...coinList, coinData.symbol]
                    }
                    await putExchange(formProps);
                }
                await this.getExchange();
                await this.getCoins();
                if (isPresetAsset && exchange.is_running) {
                    this.setState({ isPresetConfirm: true });
                }
                if (isApply) {
                    await this.handleApply();
                }
                this.handleClose();
                this.setState({ saveLoading: false, formData: {} });
                message.success('Asset created successfully');
            } catch (error) {
                this.setState({ saveLoading: false });
                if (error && error.data) {
                    message.error(error.data.message)
                }
            }
        }
    };

    handleDelete = async (symbol) => {
        const { coins, exchange } = this.state;
        try {
            const pairedData = exchange.pairs.filter(data => {
                let tempPair = data.name ? data.name : data.symbol;
                let pairData = tempPair.split('-');
                return (pairData[0] === symbol || pairData[1] === symbol)
            })
            let formProps = {
                id: exchange.id,
                coins: coins.filter(data => data.symbol !== symbol).map(data => data.symbol),
            };
            if (pairedData.length) {
                formProps.pairs = exchange.pairs.filter(data => {
                    let tempPair = data.name ? data.name : data.symbol;
                    let pairData = tempPair.split('-');
                    return (pairData[0] !== symbol && pairData[1] !== symbol)
                }).map(data => data.name ? data.name : data.symbol)
            }
            await putExchange(formProps);
            await this.getExchange();
            await this.getCoins();
            message.success('Asset removed successfully');
            this.setState({ isConfigure: false, isPreview: false });
            this.props.handleHide(false);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleEdit = (asset, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({ selectedAsset: asset, isEdit: true });
    };

    handlePreview = (asset) => {
        this.props.handleHide(true);
        this.setState({
            isPreview: true,
            selectedAsset: asset,
            status: asset.status,
            formData: {}
        });
    };

    handleConfigure = () => {
        this.props.handleHide(true);
        this.setState({ isConfigure: true, isPreview: false });
    };

    handleFilterValues = (filterValues) => {
        this.setState({ filterValues })
    }

    onClickFilter = () => {
        const { filterValues, exchange } = this.state;
        const lowercasedValue = filterValues.toLowerCase();
        let result = exchange.coins.filter(list => {
            return list.symbol.toLowerCase().includes(lowercasedValue) ||
                list.fullname.toLowerCase().includes(lowercasedValue)
        });
        this.setState({ coins: result })
    }

    handleEditData = (data) => {
        this.setState({ selectedAsset: data });
    };

    renderBreadcrumb = () => {
        return (
            <div>
                {this.state.isPreview || this.state.isConfigure
                    ?
                    <Breadcrumb>
                        <Item><Link to="/financial?tab=0">Assets</Link></Item>
                        <Item>Manage asset</Item>
                    </Breadcrumb>
                    : null
                }
            </div>
        )
    };

    applyConfirmation = () => {
        const { formData } = this.state;
        if (this.state.exchange.is_running) {
            this.setState({ isConfirm: true });
        } else {
            this.handleConfirmation(formData, true);
        }
    };

    handleConfigureEdit = (key) => {
        this.setState({
            isConfigureEdit: true,
            editConfigureScreen: key
        });
    };

    handleWithdrawalEdit = () => {
        this.handleConfigureEdit('edit_withdrawal_fees');
        this.setState({ isWithdrawalEdit: true });
    }

    renderPreview = () => {
        const { user } = this.props;
        if (this.state.isConfigure) {
            return (
                <div className="overview-wrap">
                    <div className="preview-container">
                        {this.renderBreadcrumb()}
                        <FinalPreview
                            isConfigure
                            coinFormData={this.state.selectedAsset}
                            user={user}
                            setConfigEdit={this.handleConfigureEdit}
                            handleFileChange={this.handleFileChange}
                            handleDelete={this.handleDelete}
                            handleWithdrawalEdit={this.handleWithdrawalEdit}
                        />
                    </div>
                    <div>
                        <Button
                            type="primary"
                            className="configure-btn"
                            onClick={this.applyConfirmation}
                            loading={this.state.saveLoading}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            );
        } else if (this.state.isPreview) {
            return (
                <div className="overview-wrap">
                    <div className="preview-container">
                        {this.renderBreadcrumb()}
                        <FinalPreview
                            isPreview
                            coinFormData={this.state.selectedAsset}
                            user={user}
                            handleEdit={this.handleEdit}
                            handleDelete={this.handleDelete}
                            setConfigEdit={this.handleConfigureEdit}
                            exchangeUsers={this.state.exchangeUsers}
                            userEmails={this.state.userEmails}
                            handleWithdrawalEdit={this.handleWithdrawalEdit}
                        />
                    </div>
                    {(this.state.selectedAsset.created_by === user.id || this.state.selectedAsset.owner_id === user.id)
                        ? <div>
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    // className='configure-btn'
                                    onClick={this.handleConfigure}
                                >
                                    Configure
                                </Button>
                                <div className="separator"></div>
                                {this.state.selectedAsset.verified
                                    ? (<Fragment>
                                        <Button type="primary" onClick={() => this.handleConfigureEdit('mint')}>
                                            Mint
                                        </Button>
                                        <div className="separator"></div>
                                        <Button type="primary" onClick={() => this.handleConfigureEdit('burn')}>
                                            Burn
                                        </Button>
                                    </Fragment>)
                                    : null
                                }
                            </div>
                        </div>
                        : null
                    }
                </div>
            );
        }
    };

    handleApply = async () => {
        try {
            await requestApplyOnKit(this.state.exchange.id);
            message.success('Applied changes successfully');
            this.handleConfirmationClose();
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleConfirmationClose = () => {
        this.setState({ isPresetConfirm: false });
    };

    handleFileChange = async (event, name) => {
        const file = event.target.files[0];
        if (file) {
            // const base64Url = await new Promise((resolve, reject) => {
            //     const reader = new FileReader();
            //     reader.readAsDataURL(file);
            //     reader.onload = () => resolve(reader.result);
            //     reader.onerror = error => reject(error);
            // });
            const coinFormData = {
                ...this.state.selectedAsset,
                [name]: file,
                logoFile: file,
                iconName: file.name,
            };
            this.handleEditData(coinFormData);
            this.updateFormData(name, file);
            this.updateFormData('logoFile', file);
            this.updateFormData('iconName', file.name);
        }
    };

    renderModalContent = () => {
        const {
            coins,
            isOpenAdd,
            isEdit,
            isConfigureEdit,
            editConfigureScreen,
            selectedAsset,
            isConfirm,
            exchangeUsers,
            userEmails,
            formData,
            saveLoading
        } = this.state;
        if (isConfirm) {
            return (
                <Wrapper>
                    <div className="title">Apply changes to live exchange</div>
                    <div className="content">Do you want to apply changes to the live website now?</div>
                    <div className="btn-wrapper">
                        <Button
                            type="primary"
                            className="apply-btn"
                            onClick={() => this.handleConfirmation(formData, true, false, false, true)}
                            disabled={saveLoading}
                        >
                            Save without applying
                        </Button>
                        <div className="separator"></div>
                        <Button
                            type="primary"
                            className="apply-btn"
                            onClick={() => this.handleConfirmation(formData, true, true)}
                            disabled={saveLoading}
                        >
                            Save and apply
                        </Button>
                    </div>
                </Wrapper>
            );
        } else if (isOpenAdd || isEdit || isConfigureEdit) {
            return (
                <CreateAsset
                    isOpenAdd={isOpenAdd}
                    isEdit={isEdit}
                    editAsset={selectedAsset}
                    isConfigureEdit={isConfigureEdit}
                    editConfigureScreen={editConfigureScreen}
                    coins={coins}
                    formData={formData}
                    handleEditDataCallback={this.handleEditData}
                    handleWidth={this.handleWidth}
                    handleConfirmation={this.handleConfirmation}
                    onClose={this.handleClose}
                    exchangeUsers={exchangeUsers}
                    userEmails={userEmails}
                    updateFormData={this.updateFormData}
                    getCoins={this.getCoins}
                    handleRefreshCoin={this.handleRefreshCoin}
                    isWithdrawalEdit={this.state.isWithdrawalEdit}
                    handleScreen={this.handleScreen}
                    screenChange={this.state.screenChange}
                />
            );
        }
        return null;
    };

    render() {
        const {
            isPreview,
            isConfigure,
            coins,
            isOpenAdd,
            isEdit,
            isConfigureEdit,
            width,
            isConfirm,
            isPresetConfirm,
            exchangeBalance,
            exchange
        } = this.state;
        return (
            <div className="asset-container">
                {(isPreview || isConfigure)
                    ? this.renderPreview()
                    : <Fragment>
                        <div className={this.props.constant.isExchangeExpired ? "expired-status" : ""}>
                            <div className="filter-header">
                                <Filter
                                    selectOptions={filterOptions}
                                    onChange={this.handleFilterValues}
                                    onClickFilter={this.onClickFilter}
                                />
                                <Button
                                    type="primary"
                                    className="create-asset-btn"
                                    onClick={this.handleCreateNew}
                                >
                                    Create/add asset
                                </Button>
                            </div>
                            <div className="table-wrapper">
                                <Table
                                    columns={
                                        getColumns(
                                            this.props.allCoins,
                                            this.props.user,
                                            exchangeBalance,
                                            this.handleEdit,
                                            this.handlePreview,
                                            exchange
                                        )
                                    }
                                    rowKey={(data, index) => index}
                                    dataSource={coins}
                                />
                            </div>
                        </div>
                    </Fragment>
                }
                {this.props.constant.isExchangeExpired && <ExchangeTerminateMessage />}
                <Modal
                    visible={isOpenAdd || isEdit || isConfigureEdit || isConfirm || isPresetConfirm}
                    footer={null}
                    width={`${width}px`}
                    onCancel={this.handleClose}
                >
                    {this.renderModalContent()}
                </Modal>
                <ApplyChangesConfirmation
                    isVisible={isPresetConfirm}
                    handleApply={this.handleApply}
                    handleClose={this.handleConfirmationClose}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange,
    user: state.user,
    allCoins: state.coin,
    state: state.setup.biz,
    constant: state.constant
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ExchangeAction, dispatch),
    addCoin: bindActionCreators(CoinAction.addCoin, dispatch),
    setCoin: bindActionCreators(CoinAction.setCoin, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
